import { ReactNode } from 'react'
import styled from 'styled-components'
import { colors, fontWeights } from '@/styles'
import FieldInput from '@/components/form/field-input'

const OptionText = styled.label`
  font-size: 14px;
  font-weight: ${fontWeights.medium};
  color: ${colors.darkGrey};
  margin: 0 0 0 10px;
`

const Option = styled(OptionText)`
  white-space: pre;
  cursor: pointer;
  padding: 5px 10px !important;
  min-width: 100px;

  :hover {
    border-color: ${colors.darkGrey};
  }
`

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 24px;

  > input + label {
    color: ${colors.grey16};
  }

  > input[checked] + label {
    color: ${colors.secondary};
  }
`

interface InputProps {
  id: string
  name: string
  value?: string
  onChange?: (val: string) => void
  children: ReactNode
}

const ToneRadioInput: React.FC<InputProps> = ({ id, name, value, children, onChange, ...rest }) => (
  <InputWrapper>
    <FieldInput type="radio" name={name} value={value} id={id} onToggle={onChange} />
    <Option {...rest} htmlFor={id}>
      {children}
    </Option>
  </InputWrapper>
)

export default ToneRadioInput
